import { render, staticRenderFns } from "./productManual.vue?vue&type=template&id=0df27ade&scoped=true&"
import script from "./productManual.vue?vue&type=script&lang=js&"
export * from "./productManual.vue?vue&type=script&lang=js&"
import style0 from "./productManual.vue?vue&type=style&index=0&id=0df27ade&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df27ade",
  null
  
)

export default component.exports